<div class="bg-white p-2">
  <div class="row col-lg-12">
    <button class="btn btn-cyan p-2 ml-auto text-white"><i class="fa fa-check"><span class="pl-1">Approva</span></i></button>
    <button class="btn btn-cyan p-2 ml-auto text-white" (click)="Stampa()" ><i class="far fa-print"><span class="pl-1">Stampa</span></i></button>
  </div>
  <div class="form-row col-lg-12 bg-white p-2">
    <div class="col-lg-3">
      <label>Ospite</label>
      <input class="form-control " (ngModelChange)="onInput($event)" type="text" placeholder="Scrivi un Ospite" [(ngModel)]="filtro.ospite">
    </div>
    <div class="col-lg-3">
      <label>Inizio</label>
      <input class="form-control" (ngModelChange)="onInput($event)" type="date" [(ngModel)]="filtro.inizio">
    </div>
    <div class="col-lg-3">
      <label>Fine</label>
      <input class="form-control" (ngModelChange)="onInput($event)" type="date" [(ngModel)]="filtro.fine">
    </div>
    <div class="col-lg-3">
      <span>
        <label>Stato</label>
        <ng-multiselect-dropdown [settings]="dropSetting" (ngModelChange)="onInput($event)" [placeholder]="'Seleziona uno Stato'" [data]="filtro.tipi" [(ngModel)]="filtro.selectedTipi">
        </ng-multiselect-dropdown>
      </span>
    </div>
  </div>

  <div *ngIf="Clienti && columns">
    <div class="bg-white" style="    overflow-x: scroll;">
      <table class="table">
          <thead>
              <tr>
                  <td></td>
                  <td *ngFor="let attivita of columns" style="border-right: 1px solid gray;  text-align: center;" [colSpan]="CampiColonne?.length ?? 1">{{attivita?.data_inizio_prevista | date: 'dd/MM'}}</td>
              </tr>
              <tr>
                  <td style="min-width: 12rem;border-right: 1px solid gray;">Ospiti</td>
                  <ng-container *ngIf="!CampiColonne "><td *ngFor="let attivita of columns" colspan="1"> </td></ng-container>
                
              </tr>
          </thead>
          <tbody>
              <tr *ngFor="let cliente of Clienti">
                  <td style="border-right: 1px solid gray;">{{cliente.fullName ?? cliente.nominativo}}</td>
                  <ng-container *ngFor="let column of columns; let i = index">
                      <ng-container *ngFor="let attivita of column.Tasks; let j = index">
                          <ng-container  *ngIf="cliente.id == attivita.cliente">

                            <td (click)="Click(attivita.task)"> <i [ngbTooltip]="Tooltip(attivita.task) ?? 'N/A'" [ngClass]="BadgeSelect(attivita.task)"></i> </td>
                          </ng-container>
                      </ng-container>
                  </ng-container>
              </tr>
          </tbody>
      </table>
      <div class="m-t-10" *ngIf="hasSave">
        <button type="submit" type="button" [ngClass]="'btn'"    (click)='Save()'>
          <i [ngClass]="'fas f text-info'" class="font-14 mr-1 "></i>
          <span [ngClass]="'text-info'"> {{'Fine' | translate}} </span>
        </button>
      </div>
  </div>
  </div>

  <!-- <div class="control-section pt-2">
    <ejs-gantt
    #gantt
    *ngIf='data?.length > 0'
    id="ganttDefault" height="430px"
    [(dataSource)]="data"
    [taskFields]="taskSettings"
    [dayWorkingTime]="dayWorkingTime"
    [editSettings]="editSettings"
    [columns]="columns"
    [timelineSettings]="timelineSettings"
    [includeWeekend] = 'true'
    [tooltipSettings] = 'tooltipSettings'
    [toolbar]="toolbar"
    (toolbarClick)="toolbarClick($event)"
    allowPdfExport='true'
    [allowUnscheduledTasks]="true"
    [projectStartDate]="filtro.inizio"
    [projectEndDate]="addOneFiltroFine()"
    (pdfQueryCellInfo)="pdfQueryCellInfo($event)"
  >
  </ejs-gantt>
  </div> -->

  <div>
    <app-legenda [legenda]="legenda"></app-legenda>
  </div>
</div>
